var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1099 1.23828C19.7938 0.920573 19.2809 0.920573 18.9648 1.23828L10.6739 10.3356L2.38214 1.23828C2.06605 0.920573 1.55317 0.920573 1.23707 1.23828C0.920976 1.55599 0.920976 2.07127 1.23707 2.38895L10.0602 12.07C10.2288 12.2394 10.4529 12.3119 10.6731 12.3007C10.894 12.3119 11.1174 12.2394 11.2859 12.07L20.1099 2.38809C20.426 2.07045 20.426 1.55599 20.1099 1.23828Z",
    fill: "#192830",
    stroke: "#192830",
    strokeWidth: 1.38192
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.7997cd5f0e6c5fe40765080b9de7359f.svg";
export { ForwardRef as ReactComponent };